import { Grid } from '@mui/material';
import { DataGrid, gridClasses, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getWorkspaceActivityMetrics } from 'wisestep-api';
import { WsColors, WsTypography } from 'wisestep-base';

interface WorkspaceActivityMetrics {
  workspaceName: string;
  owner_id: string;
  activeUsers: number;
  lastActivityDate: string;
  planType: string;
}

const WorkspaceActivityMetrics = () => {
  const [workspaceData, setWorkspaceData] = useState<WorkspaceActivityMetrics[]>([]);
  //   const [pageInfo, setPageInfo] = useState<{ pageSize: number; pageNumber: number }>({
  //     pageSize: 10,
  //     pageNumber: 0,
  //   });
  //   const [totalRecords, setTotalRecords] = useState<number>(0);

  const tableData = useMemo(() => {
    const data = workspaceData.map((workspaceObj) => ({
      id: uuidv4(),
      workspaceName: workspaceObj?.workspaceName,
      owner_id: workspaceObj.owner_id,
      planType: workspaceObj?.planType,
      lastActivityDate: workspaceObj?.lastActivityDate,
      activeUsers: Number(workspaceObj?.activeUsers),
    }));

    const totalCountOfUsers = data.reduce(
      (prevSum, currentObj) => prevSum + currentObj.activeUsers,
      0
    );
    return { data, totalCountOfUsers };
  }, [workspaceData]);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'id', hide: true },
    { field: 'workspaceName', headerName: 'Workspace Name', flex: 1 },
    { field: 'owner_id', headerName: 'Owner Email', flex: 1.7 },
    { field: 'planType', headerName: 'Plan Type', flex: 1 },
    { field: 'lastActivityDate', headerName: 'Last Activity Date', flex: 1, type: 'date' },
    { field: 'activeUsers', headerName: `Active Users (${tableData.totalCountOfUsers})`, flex: 1 },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const req = await getWorkspaceActivityMetrics();
      setWorkspaceData(req.data);
      //   setTotalRecords(parseInt(req.headers['x-total-count']));
    };
    fetchData();
  }, []);

  return (
    <Grid item xs={10} bgcolor={WsColors.White} height={690}>
      <WsTypography bold>Workspaces Activity in last 7 days</WsTypography>
      <DataGrid
        columns={columns}
        rows={tableData.data}
        components={{ Toolbar: GridToolbar }}
        getRowHeight={() => 'auto'}
        sx={{
          [`& .${gridClasses.cell}`]: {
            py: 2,
          },
        }}
        pageSize={10}
      />
    </Grid>
  );
};

export default WorkspaceActivityMetrics;
